import { Icons } from "assets";
import { routeConstant } from "shared/routes/routeConstant";

const sideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.dashboard.path,
        title: routeConstant.dashboard.title,
        Icon: Icons.DashboardHome,
      },
      {
        path: routeConstant.questionaire.path,
        title: routeConstant.questionaire.title,
        Icon: Icons.DashboardQuestionnaire,
      },
      {
        path: routeConstant.evaluationRecord.path,
        title: "All Evaluations",
        Icon: Icons.DashboardEvaluations,
        subPaths: [
          {
            path: routeConstant.evaluationRecord.path,
            title: routeConstant.evaluationRecord.title,
            Icon: Icons.DashboardHistory,
          },
          {
            path: routeConstant.archiveEvaluationRecord.path,
            title: routeConstant.archiveEvaluationRecord.title,
            Icon: Icons.DashboardArchive,
          },
        ],
      },
      {
        path: routeConstant.draftEvaluation.path,
        title: routeConstant.draftEvaluation.title,
        Icon: Icons.DashboardDraftEvaluations,
      },
      {
        path: routeConstant.flagEvaluation.path,
        title: routeConstant.flagEvaluation.title,
        Icon: Icons.DashboardFlagEvaluations,
      },
      {
        path: routeConstant.cgpEvaluation.path,
        title: routeConstant.cgpEvaluation.title,
        Icon: Icons.DashboardCGPEvaluations,
      },
      {
        path: routeConstant.reqEvaluation.path,
        title: routeConstant.reqEvaluation.title,
        Icon: Icons.DashboardReqEvaluations,
      },
    ],
  },
  {
    title: "Help",
    paths: [
      {
        path: routeConstant.contact.path,
        title: routeConstant.contact.title,
        Icon: Icons.DashboardContact,
      },
    ],
  },
];

const SettingsTabs = ["Account Information", "Change Password"];
const SettingsTabsEnums = {
  account: "Account Information",
  changePassword: "Change Password",
};

const homeSideBarConstants: SideBarItemPathType[] = [
  {
    path: routeConstant.home.path,
    title: routeConstant.home.title,
  },
  {
    path: routeConstant.aboutUS.path,
    title: routeConstant.aboutUS.title,
  },
  {
    path: routeConstant.contactUs.path,
    title: routeConstant.contactUs.title,
  },
];

const ColumnHeads: CustomTableHeadType[] = [
  {
    title: "Active",
    key: "isActive",
  },
  {
    title: "Job Title",
    key: "jobTitle",
  },
  {
    title: "Department",
    key: "department",
  },
  {
    title: "Job Code",
    key: "jobeCode",
  },
  {
    title: "Job Grade",
    key: "jobGrade",
  },
  {
    title: "Role Type",
    key: "roleType",
  },
  {
    title: "Level of Work & Modifier",
    key: "level_of_work.short_des",
  },
  {
    title: "Institutional Expertise & Skill",
    key: "q2.short_des",
  },
  {
    title: "Cultural Impact",
    key: "q3.short_des",
  },
  {
    title: "Physical Environment",
    key: "q4.short_des",
  },
  {
    title: "Mental & Emotional Environment",
    key: "q5.short_des",
  },
  {
    title: "Application of Knowledge & Skill",
    key: "q6.short_des",
  },
  {
    title: "Manual Effort",
    key: "q7.short_des",
  },
  {
    title: "Outcomes",
    key: "q8.short_des",
  },
  {
    title: "RAS Score",
    key: "rasScore",
  },
  {
    title: "RAS Level",
    key: "rasLevel",
  },
  {
    title: "RAS Code",
    key: "shortCode",
  },
  {
    title: "Evaluated By",
    key: "evaluated_by.name",
  },
  {
    title: "Last Date Modified",
    key: "created_at",
  },
  {
    title: "Action",
    key: "shortCode",
  },
];

const CGPColumnHeads: CustomTableHeadType[] = [
  {
    title: "Job Title",
    key: "jobTitle",
  },
  {
    title: "Department",
    key: "department",
  },
  {
    title: "Job Code",
    key: "jobeCode",
  },
  {
    title: "Job Grade",
    key: "jobGrade",
  },
  {
    title: "Role Type",
    key: "roleType",
  },
  {
    title: "Level of Work & Modifier",
    key: "level_of_work.short_des",
  },
  {
    title: "Institutional Expertise & Skill",
    key: "q2.short_des",
  },
  {
    title: "Cultural Impact",
    key: "q3.short_des",
  },
  {
    title: "Physical Environment",
    key: "q4.short_des",
  },
  {
    title: "Mental & Emotional Environment",
    key: "q5.short_des",
  },
  {
    title: "Application of Knowledge & Skill",
    key: "q6.short_des",
  },
  {
    title: "Manual Effort",
    key: "q7.short_des",
  },
  {
    title: "Outcomes",
    key: "q8.short_des",
  },
  {
    title: "RAS Score",
    key: "rasScore",
  },
  {
    title: "RAS Level",
    key: "rasLevel",
  },
  {
    title: "RAS Code",
    key: "shortCode",
  },
  {
    title: "Evaluated By",
    key: "evaluated_by.name",
  },
  {
    title: "Last Date Modified",
    key: "created_at",
  },
  {
    title: "Action",
    key: "shortCode",
  },
];

const FixedColumns = [
  "Active",
  "Job Title",
  "RAS Score",
  "RAS Level",
  "RAS Code",
  "Evaluated By",
  "Last Date Modified",
  "Action",
];

export {
  sideBarConstants,
  SettingsTabs,
  SettingsTabsEnums,
  homeSideBarConstants,
  ColumnHeads,
  FixedColumns,
  CGPColumnHeads,
};
